import Image from "next/legacy/image";
interface GNOBannerProps {}

const GNOBanner: React.FC<GNOBannerProps> = () => {
  return (
    <section className="container h-full px-8 mx-auto">
      <section className="grid items-center h-full grid-cols-1 gap-8 md:grid-cols-2 xl:gap-16">
        <h1 className="md:px-0 sm:px-10 text-4xl md:text-left text-center md:text-3xl lg:text-4xl xl:text-5xl text-careerPageHeading xl:leading-[3.5rem] font-semibold">
          Your high-growth, high-wage career is waiting for you.
        </h1>
        <figure className="">
          <Image
            src="https://res.cloudinary.com/wherewego/image/upload/v1657862839/WWG2000%20Site%20Photos/vq0phv6m7zoxptnhkh0i.png"
            blurDataURL="https://res.cloudinary.com/wherewego/image/upload/v1657862839/WWG2000%20Site%20Photos/vq0phv6m7zoxptnhkh0i.png"
            layout="responsive"
            loading="eager"
            placeholder="blur"
            width={575}
            height={430}
            alt="Welder"
            className=""
          />
        </figure>
      </section>
    </section>
  );
};

export default GNOBanner;
